module.exports = __webpack_public_path__ + "dc1772ba1b2f9bc562a7aa3408ca196f.jpg";